import { Config } from '../../../services/core/config';

const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';

const Logout = () => {
  Config.removeTokenAuthUser();
  localStorage.removeItem(TOKEN_NAME);
  sessionStorage.removeItem(TOKEN_NAME);
  window.location.replace(`/logout`);
};

const ClearToken = () => {
  Config.removeTokenAuthUser();
  localStorage.removeItem(TOKEN_NAME);
  sessionStorage.removeItem(TOKEN_NAME);
};

export const FirstAccessHelpers = {
  Logout,
  ClearToken,
};
